import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GtwCustomSnackbarComponent, GtwSnackbarData, GtwSnackbarPanelClass } from '../components/gtw-custom-snackbar/gtw-custom-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class GtwSnackbarService {

  constructor(private _snackBar: MatSnackBar) { }

  openSnackBar(
    message: string, 
    panelClass: GtwSnackbarPanelClass = '', 
    closable: boolean = true,
    durationInSeconds: number = 4
  ) {

    if (closable === false && durationInSeconds === 0) {
      throw new Error('Snackbar must be closable or have a duration');
    }

    const data: GtwSnackbarData = {
      message: message,
      closable: closable
    };

    return this._snackBar.openFromComponent(GtwCustomSnackbarComponent, {
      duration: durationInSeconds * 1000,
      panelClass: panelClass ? [panelClass] : [],
      data: data,
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }
}
